var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_c2e093918e4814b046891b81aeb2e954daeace3e50f77266d38023484b97abf9",
    x1: 70.12,
    y1: 26.5,
    x2: 83.1,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M124.07 25.51h12.38c2.6 0 4.71 2.34 4.71 5.22v102c0 2.88-2.11 5.22-4.71 5.22H58.64c-2.6 0-4.71-2.34-4.71-5.22v-102c0-2.88 2.11-5.22 4.71-5.22h12.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M75.67 20.33s-5.65-8.48 2.51-8.48 2.83 8.48 2.83 8.48",
    stroke: "url(#SVGID_0_c2e093918e4814b046891b81aeb2e954daeace3e50f77266d38023484b97abf9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.25 34.69H71.43l2.26-13.5H83l2.25 13.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M114.61 20.33s-5.65-8.48 2.51-8.48 2.83 8.48 2.83 8.48",
    stroke: "url(#SVGID_0_c2e093918e4814b046891b81aeb2e954daeace3e50f77266d38023484b97abf9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M124.19 34.69h-13.82l2.25-13.5h9.32l2.25 13.5zM84.62 25.54h26.59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M121.09 85.12l4.42-5.84M125.51 85.12l-4.42-5.84M129.06 79.6l2.21 2.93 2.21-2.93M131.26 85.44V82.4M113.24 79.28h4.09l-4.1 5.84h4.1M133.53 108.31l-4.42 5.84M133.53 114.15l-4.42-5.84M113.12 108.31l2.21 2.93 2.22-2.93M115.33 114.15v-3.04M121.15 108.31h4.09l-4.1 5.84h4.1M113.17 56.09l4.42-5.83M117.59 56.09l-4.42-5.83M121.04 50.26l2.21 2.92 2.22-2.92M123.25 56.09v-3.03M129.16 50.27h4.1l-4.1 5.83h4.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_c2e093918e4814b046891b81aeb2e954daeace3e50f77266d38023484b97abf9)",
    d: "M62.59 47.21h43.6v12.33h-43.6zM62.59 75.1h43.6v12.33h-43.6zM62.59 105.27h43.6v12.33h-43.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTemplates);
export default __webpack_public_path__ + "static/media/itemTemplates.a0c66ecdc6456d90a3794ed168c1a963.svg";
export { ForwardRef as ReactComponent };